<template>
  <div class="lf-be" ref="lf-be" :size="size" v-if="is_authenticated()">
    <div class="lf-be--block--options">
      <b-row>
        <b-col cols="12" md="6" class="lf-be--option lf-be--option-destination px-0">
          <b-button
            variant="light"
            :class="return_flight ? 'selected' : ''"
            @click="
              () => {
                return_flight = true;
              }
            "
          >
            Andata e ritorno
          </b-button>
          <b-button
            variant="light"
            :class="return_flight ? '' : 'selected'"
            @click="
              () => {
                return_flight = false;
              }
            "
          >
            Solo andata
          </b-button>
        </b-col>

        <b-col cols="12" md="6" class="lf-be--option px-0">
          <div class="lf-be--option--wrapper">
            <div class="lf-be--occupancy--wrapper" v-on-click-outside="hide_occupancy_content">
              <b-button
                variant="light"
                :class="return_flight ? '' : 'selected'"
                @click="
                  () => {
                    show_occupancy = !show_occupancy;
                  }
                "
              >
                <div>
                  {{ travelers.length }}
                  {{ travelers.length > 1 ? 'passeggeri' : 'passeggero' }}
                </div>
                <div v-html="chevron_down"></div>
              </b-button>
              <div class="lf-be--occupancy--content" v-if="show_occupancy">
                <occupancy
                  @close="hide_occupancy_content"
                  @updated="
                    (occupancy) => {
                      let updated_travelers = [],
                        id = 1,
                        associated_adult_id = 1;

                      for (a = 1; a <= occupancy.adults; a++) {
                        updated_travelers.push({
                          id: id,
                          travelerType: 'ADULT',
                          fareOptions: ['STANDARD'],
                        });
                        id++;
                      }

                      occupancy.children.forEach((c) => {
                        let child = {
                          id: id,
                          travelerType: 'CHILD',
                          fareOptions: ['STANDARD'],
                        };

                        if (c < 2) {
                          child.travelerType = 'HELD_INFANT';
                          child.associatedAdultId = associated_adult_id;
                          associated_adult_id++;
                        }

                        updated_travelers.push(child);
                        id++;
                      });

                      this.travelers = updated_travelers;
                      this.adults = occupancy.adults;
                      this.children = occupancy.children;
                    }
                  "
                  :max_adults="config.guiSettings.searchMaxAdults"
                  :max_children="config.guiSettings.searchMaxChildren"
                />
              </div>
            </div>
            <div class="lf-be--checkbox">
              <search-by-connections />
            </div>

            <div class="lf-be--checkbox" v-if="false">
              <search-by-bags />
            </div>
            <div class="lf-be--select" v-if="false">
              <search-by-cabin />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="lf-be--block--form">
      <b-row class="justify-content-end">
        <button ref="hidden_input" class="focus-dump-button"></button
        ><!--serve per togliere il focus dagli autocomplete dopo il click, così poi al focus si seleziona di nuovo tutto il testo ed è più semplice cancellarlo-->

        <b-col
          :sm="!return_flight ? '8' : '0'"
          lg="8"
          class="lf-be--form-item lf-be--form-item-1 px-0"
        >
          <div class="lf-be--block--departure">
            <autocomplete
              class="lf-be--autocomplete"
              :search="search"
              :placeholder="departure_airport_label"
              :debounce-time="500"
              @submit="on_submit_departure_airport"
              :get-result-value="get_result_value"
              @click="autocomplete_click_departure_airport"
              @focus="
                ($event) => {
                  $event.target.select();
                }
              "
            >
              <template v-slot:result="scope">
                <li
                  :key="scope.props.id"
                  v-bind="scope.props"
                  :data-type="scope.result.type"
                  v-html="scope.result.name_full"
                ></li>
              </template>
            </autocomplete>
          </div>
          <div class="lf-be--block--return" ref="lf-be--block--return">
            <autocomplete
              class="lf-be--autocomplete"
              :search="search"
              :placeholder="arrival_airport_label"
              :debounce-time="500"
              @submit="on_submit_arrival_airport"
              :get-result-value="get_result_value"
              @click="autocomplete_click_arrival_airport"
              @focus="
                ($event) => {
                  $event.target.select();
                }
              "
            >
              <template v-slot:result="scope">
                <li
                  :key="scope.props.id"
                  v-bind="scope.props"
                  :data-type="scope.result.type"
                  v-html="scope.result.name_full"
                ></li>
              </template>
            </autocomplete>
          </div>
        </b-col>
        <b-col
          :sm="!return_flight ? '4' : '0'"
          :lg="size == 'default' ? '4' : '3'"
          class="lf-be--form-item lf-be--form-item-2 px-0"
        >
          <div class="lf-be--block--departure_date" v-on-click-outside="hide_calendar_departure">
            <label>Andata</label>
            <b-form-input
              :value="reverse_date(departure_date)"
              @click="toggle_calendar('departure')"
              type="text"
              placeholder="Partenza"
              @focus="is_mobile() && scroll_into_view()"
            />
            <div v-if="show_departure_date" class="lf-be--datepicker--departure">
              <v-date-picker
                v-model="departure_date"
                :model-config="model_config_datepicker"
                :min-date="departure_min_date"
                :max-date="get_max_date()"
              />
              <div class="lf-be--datepicker--calendar-data">
                <b-alert
                  v-if="disclaimer"
                  variant="warning"
                  class="lf-be--datepicker--calendar-data--warning"
                  show
                >
                  <span v-html="disclaimer"></span>
                </b-alert>
                <b-button
                  size="sm"
                  variant="cta"
                  @click="
                    () => {
                      show_departure_date = false;
                    }
                  "
                >
                  FATTO
                </b-button>
              </div>
            </div>
          </div>

          <div v-if="return_flight" class="lf-be--block--return_date">
            <div v-on-click-outside="hide_calendar_return">
              <label>Ritorno</label>
              <b-form-input
                :disabled="!return_flight"
                :value="reverse_date(return_date)"
                @click="toggle_calendar('return')"
                type="text"
                placeholder="Ritorno"
                @focus="is_mobile() && scroll_into_view()"
              />
              <div v-if="show_return_date" class="lf-be--datepicker--return">
                <v-date-picker
                  v-model="return_date"
                  :model-config="model_config_datepicker"
                  :min-date="return_min_date"
                  :max-date="get_max_date()"
                />

                <div class="lf-be--datepicker--calendar-data">
                  <b-alert
                    v-if="disclaimer"
                    variant="warning"
                    class="lf-be--datepicker--calendar-data--warning"
                    show
                  >
                    <span v-html="disclaimer"></span>
                  </b-alert>
                  <b-button
                    size="sm"
                    variant="cta"
                    @click="
                      () => {
                        show_return_date = false;
                      }
                    "
                  >
                    FATTO
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </b-col>

        <b-col
          sm="12"
          md="2"
          :lg="size == 'default' ? '2' : '1'"
          class="lf-be--form-item lf-be--form-item-3 px-0"
        >
          <div class="lf-be--buttons">
            <b-button
              class="btn-block px-0 font-weight-bold d-flex align-items-center justify-content-center"
              variant="tertiary"
              type="submit"
              @click="handle_search_submit_button"
              :disabled="!can_search()"
            >
              <span>Cerca</span>
              <!-- <span v-show="!this.$store.state.liveflight.loading">Cerca</span> -->
              <b-spinner v-show="this.$store.state.liveflight.loading" />
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import Occupancy from '@/components/blocks/occupancy';
import SearchByConnections from '@/components/blocks/search-by-connections';
import SearchByBags from '@/components/blocks/search-by-bags';
import SearchByCabin from '@/components/blocks/search-by-cabin';
import {
  parse_flight_offers,
  is_authenticated,
  reverse_date,
  is_mobile,
  remove_time_from_date,
  get_config,
} from '@/utilities';
import { get_locations, get_flight_offers } from '@/api';
import { chevron_down } from '@/components/svg/chevrons';
import moment from 'moment';

Vue.use(VCalendar);

export default {
  name: 'liveflight-booking-engine',
  components: {
    autocomplete: Autocomplete,
    occupancy: Occupancy,
    'search-by-connections': SearchByConnections,
    'search-by-bags': SearchByBags,
    'search-by-cabin': SearchByCabin,
  },
  props: {
    size: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    adults: {
      get() {
        return this.$store.state.liveflight.adults;
      },
      set(value) {
        this.$store.commit('adults', value);
      },
    },
    children: {
      get() {
        return this.$store.state.liveflight.children;
      },
      set(value) {
        this.$store.commit('children', value);
      },
    },
    travelers: {
      get() {
        return this.$store.state.liveflight.travelers;
      },
      set(value) {
        this.$store.commit('travelers', value);
      },
    },
    departure_airport: {
      get() {
        return this.$store.state.liveflight.departure_airport;
      },
      set(value) {
        this.$store.commit('departure_airport', value);
      },
    },
    departure_airport_label: {
      get() {
        return this.$store.state.liveflight.departure_airport_label
          ? this.$store.state.liveflight.departure_airport_label
          : 'Partenza da...';
      },
      set(value) {
        this.$store.commit('departure_airport_label', value.replace(/<[^>]*>?/gm, ''));
      },
    },
    arrival_airport: {
      get() {
        return this.$store.state.liveflight.arrival_airport;
      },
      set(value) {
        this.$store.commit('arrival_airport', value);
      },
    },
    arrival_airport_label: {
      get() {
        return this.$store.state.liveflight.arrival_airport_label
          ? this.$store.state.liveflight.arrival_airport_label
          : 'Arrivo a...';
      },
      set(value) {
        this.$store.commit('arrival_airport_label', value.replace(/<[^>]*>?/gm, ''));
      },
    },
    departure_date: {
      get() {
        return this.$store.state.liveflight.departure_date;
      },
      set(value) {
        this.$store.commit('departure_date', value);
      },
    },
    return_date: {
      get() {
        return this.$store.state.liveflight.return_date;
      },
      set(value) {
        this.$store.commit('return_date', value);
      },
    },
    return_flight: {
      get() {
        return this.$store.state.liveflight.return_flight;
      },
      set(value) {
        this.$store.commit('return_flight', value);
      },
    },
    departure_min_date: {
      get() {
        let min_date = moment();
        try {
          const minCheckin = get_config('guiSettings.minCheckin', undefined);
          if (minCheckin && moment(min_date).diff(minCheckin, 'days') < 0) {
            min_date = moment(minCheckin);
          }

          min_date.add(this.config.guiSettings.minDays, 'days');
          if (moment().hour() > 13) {
            min_date.add(1, 'days');
          }
        } catch (e) {
          this.log('booking-engine.departure_min_date', e);
        }
        return min_date.toDate();
      },
      set() {},
    },
    return_min_date: {
      get() {
        return moment(this.departure_date).toDate();
      },
      set() {},
    },
    can_search_suggestions: {
      get() {
        return this.$store.state.liveflight.can_search_suggestions;
      },
      set(value) {
        this.$store.commit('can_search_suggestions', value);
      },
    },
    disclaimer() {
      return get_config('guiSettings.minDisclaimer', '');
    },
  },
  data() {
    return {
      config: Vue.prototype.$config,
      /*
                options: {
                    adults: [1,2,3,4],
                    max_number_of_connections: [0, 1, 2],
                },
                */
      model_config_datepicker: {
        type: 'string',
        mask: 'YYYY-MM-DD', // Uses 'iso' if missing
      },
      //interfaccia
      show_departure_date: false,
      show_return_date: false,
      show_occupancy: false,
      request: {},
    };
  },
  created() {
    this.is_authenticated = is_authenticated;
    this.chevron_down = chevron_down;
    this.reverse_date = reverse_date;
    this.is_mobile = is_mobile;
    this.remove_time_from_date = remove_time_from_date;
    this.moment = moment;
  },

  mounted() {
    // questi sono listener sull'eventBus: se non li tolgo ne viene creato uno ad ogni mounted() del componente
    window.eventBus.$off('trigger-search-by-suggestion'); // se non ho avuto risultati alla ricerca ed ho cliccato su una suggestion
    window.eventBus.$on('trigger-search-by-suggestion', () => {
      this.handle_trigger_search();
    });

    window.eventBus.$off('change-search-by'); // se ho cliccato su uno dei filtri che devono lanciare una nuova ricerca (search-by-*)
    window.eventBus.$on('change-search-by', () => {
      // triggero la ricerca SOLO se sono nella pagina risultati
      if (this.$route.name !== 'results') return;
      this.handle_trigger_search();
    });

    //NB il controllo sull'orario (per posticipare di 1d dalle 14 in poi) è gestito nella computed departure_min_date
    //if(process.env.VUE_APP_START_SEARCH) this.search_flights()
    const departure_min_date = moment(this.departure_min_date).format('YYYY-MM-DD');
    let departure_date = moment(this.departure_date).format('YYYY-MM-DD');
    let return_min_date = moment(this.return_min_date).format('YYYY-MM-DD');
    let return_date = moment(this.return_date).format('YYYY-MM-DD');

    //window.console.log('INIT', departure_min_date, departure_date, return_min_date, return_date)
    if (departure_date < departure_min_date) {
      departure_date = departure_min_date;
      return_min_date = moment(departure_date).add(1, 'd').format('YYYY-MM-DD');
      this.departure_min_date = departure_min_date;
      this.return_min_date = return_min_date;
      this.$store.commit('departure_date', departure_date);
      this.$store.commit('return_date', return_min_date);
      //window.console.log('POST', departure_min_date, departure_date, return_min_date, return_date)
    }

    // make sure min date and actual date are aligned for return date
    if (moment(return_min_date).diff(return_date) > 0) {
      this.return_date = moment(return_min_date).add(1, 'd').format('YYYY-MM-DD');
    }
  },

  methods: {
    handle_search_submit_button() {
      this.can_search_suggestions = true;
      this.$store.commit('suggestions', {});
      this.search_flights();
    },
    handle_search_suggestions() {
      this.can_search_suggestions = false;

      this.$store.commit('suggestions', {});

      if (Object.keys(this.request) == 0) return;

      this.$store.commit('toggle_loading');

      let request_by_radius = {
          ...this.create_search_request(),
        },
        request_by_time_window = {
          ...this.create_search_request(),
        };

      // imposto ricerca per aeroporti vicini (sia andata sia eventuale ritorno)
      request_by_radius.originDestinations.forEach((o) => {
        o.originRadius = 100;
        o.destinationRadius = 100;
      });

      // nelle ricerche "a raggio" disattivo returnToDepartureAirport
      // altrimenti potrebbe cercare voli con ritorno sull'aeroporto del booking engine (e quindi nessun risultato)
      // (non si comporta sempre così, altre ricerche a raggio ritornano risultati anche con flag a true)
      if (request_by_radius.searchCriteria && request_by_radius.searchCriteria.flightFilters) {
        request_by_radius.searchCriteria.flightFilters.returnToDepartureAirport = false;
      }

      // imposto ricerca con date flessibili (sia andata sia eventuale ritorno)
      request_by_time_window.originDestinations.forEach((o) => {
        o.departureDateTimeRange.dateWindow = 'I3D';
      });

      let get_suggestions_promises = [
        get_flight_offers({ getFlightOffersBody: request_by_radius }),
        get_flight_offers({ getFlightOffersBody: request_by_time_window }),
      ];

      Promise.all(get_suggestions_promises).then(
        (response) => {
          let suggestions = {
            by_radius: parse_flight_offers(response[0].data), // risultati ricerca aeroporti vicini
            by_time_window: parse_flight_offers(response[1].data), // risultati ricerca date flessibili
          };
          this.$store.commit('suggestions', suggestions);
          this.$store.commit('toggle_loading');
        },
        (error) => {
          error;
          this.$store.commit('suggestions', {});
          this.$store.commit('toggle_loading');
        }
      );
    },
    handle_trigger_search() {
      this.search_flights();
    },
    can_search() {
      if (this.$store.state.liveflight.loading == true) return false;
      if (!this.departure_date | (this.departure_date == '')) return false;
      if (!this.departure_airport | (this.departure_airport == '')) return false;
      if (!this.arrival_airport | (this.arrival_airport == '')) return false;
      if (this.return_flight) {
        if (!this.return_date | (this.return_date == '')) return false;
      }
      return true;
    },
    get_max_date() {
      let today = new Date(),
        max_date = new Date(today);
      max_date.setDate(today.getDate() + 365);
      return max_date;
    },
    hide_occupancy_content() {
      this.show_occupancy = false;
    },
    hide_calendar_departure() {
      this.show_departure_date = false;
    },
    hide_calendar_return() {
      this.show_return_date = false;
    },
    toggle_calendar(calendar) {
      if (calendar == 'departure') {
        this.show_departure_date = !this.show_departure_date;
        this.show_return_date = false;
      }
      if (calendar == 'return') {
        this.show_return_date = !this.show_return_date;
        this.show_departure_date = false;
      }
    },
    search(q) {
      if (!q | (q == '') | (q == this.departure_airport_label)) return []; //impedisce chiamare indesiderate
      return get_locations({
        q: q,
      });
    },
    get_result_value(result) {
      return `${result.name_full}`.replace(/<[^>]*>?/gm, '');
    },
    on_submit_departure_airport(result) {
      this.$refs.hidden_input.focus();
      this.departure_airport = result.iata_code;
      this.departure_airport_label = result.name_full;
    },
    on_submit_arrival_airport(result) {
      this.$refs.hidden_input.focus();
      this.arrival_airport = result.iata_code;
      this.arrival_airport_label = result.name_full;
    },
    autocomplete_click_departure_airport() {
      //this.on_click_autocomplete()
    },
    autocomplete_click_arrival_airport() {
      //this.on_click_autocomplete()
    },
    create_search_request() {
      // REQUEST
      let request = {
        currencyCode: 'EUR',
        originDestinations: [
          {
            id: '1',
            originLocationCode: this.$store.state.liveflight.departure_airport,
            destinationLocationCode: this.$store.state.liveflight.arrival_airport,
            departureDateTimeRange: {
              date: this.$store.state.liveflight.departure_date,
              //'time': '10:00:00'
            },
          },
        ],
        travelers: [],
        sources: ['GDS'],
        searchCriteria: {
          addOneWayOffers: false,
          flightFilters: {
            returnToDepartureAirport: true,
            connectionRestriction: {
              maxNumberOfConnections: this.$store.state.liveflight.max_number_of_connections,
            },
          },
          pricingOptions: {
            includedCheckedBagsOnly:
              this.$store.state.liveflight.included_checked_bags_only == 1 ? true : false,
          },
          additionalInformation: {
            chargeableCheckedBags: true,
          },
          allowAlternativeFareOptions: get_config(
            'searchSettings.allowAlternativeFareOptions',
            false
          ),
        },
      };

      // CABIN
      if (
        ['ECONOMY', 'PREMIUM_ECONOMY', 'BUSINESS', 'FIRST'].includes(
          this.$store.state.liveflight.cabin
        )
      ) {
        request.searchCriteria.flightFilters.cabinRestrictions = [
          {
            cabin: this.$store.state.liveflight.cabin, // cabin_options
            coverage: 'ALL_SEGMENTS', // MOST_SEGMENTS|AT_LEAST_ONE_SEGMENT|ALL_SEGMENTS,
            originDestinationIds: ['1'],
          },
        ];
      }

      // TRAVELERS
      request.travelers = this.travelers;

      // RETURN
      if (this.return_flight) {
        request.originDestinations.push({
          id: '2',
          originLocationCode: this.$store.state.liveflight.arrival_airport,
          destinationLocationCode: this.$store.state.liveflight.departure_airport,
          departureDateTimeRange: {
            date: this.$store.state.liveflight.return_date,
          },
        });
        if (
          request.searchCriteria.flightFilters &&
          request.searchCriteria.flightFilters.cabinRestrictions
        ) {
          request.searchCriteria.flightFilters.cabinRestrictions[0].originDestinationIds.push('2');
        }
      }

      return request;
    },
    search_flights() {
      this.$store.commit('toggle_loading');
      this.$store.commit('results', {});
      this.$store.commit('suggestions', {});
      this.request = this.create_search_request();

      let params = {
        // spread operator per evitare che originRadius/destinationRadius finiscano anche nella variabile data() del componente
        getFlightOffersBody: {
          ...this.request,
        },
      };

      // forzo risultati a zero per testare le suggestions
      /*if(process.env.VUE_APP_MODE != 'production'){
                  params.getFlightOffersBody.tests = {}
                  params.getFlightOffersBody.tests.noresults = this.can_search_suggestions
                }*/

      // resetto filtri di ricerca indersiderati
      this.$store.commit('filter_carriers', []);

      return get_flight_offers(params).then(
        (response) => {
          let parsed_flight_offers = parse_flight_offers(response.data);
          this.$store.commit('results', parsed_flight_offers);
          this.$store.commit('toggle_loading');
          if (this.$router.history.current.name !== 'results')
            this.$router.push({ path: 'results' });

          if (this.$config.guiSettings.enableNoResultsSearchSuggestions == undefined) return;
          if (this.$config.guiSettings.enableNoResultsSearchSuggestions == false) return;

          if (this.can_search_suggestions && parsed_flight_offers.flights.length == 0)
            this.handle_search_suggestions();
        },
        (error) => {
          error;
          this.$store.commit('toggle_loading');
        }
      );
    },
    scroll_into_view() {
      this.$refs['lf-be--block--return'].scrollIntoView({ behavior: 'smooth' });
    },
    generate_return_date_parameters(departure_date) {
      // Make sure the return date is always over the departure
      if (moment(departure_date).diff(this.return_date) > 0) {
        this.return_date = departure_date;
      }
    },
  },

  watch: {
    departure_date: function () {
      this.show_departure_date = false;
      if (this.return_flight) {
        // nextTick non è sufficiente: serve un altro record di attivazione
        setTimeout(() => {
          this.show_return_date = true;
        }, 1);
      }
    },
    return_date: function () {
      this.show_return_date = false;
    },
  },
};
</script>

<style lang="scss">
.lf-be {
  @extend .panel !optional;

  @include media-breakpoint-down(md) {
    padding: $grid-gutter-width;
  }

  &[size='sm'] {
    border-width: 0;
    padding: $grid-gutter-width/2;
    border-radius: 0;
  }

  &--block {
    &--options {
      margin-bottom: $grid-gutter-width/2;

      @include media-breakpoint-up(md) {
        margin-bottom: $grid-gutter-width;
      }

      .btn:not(.selected) {
        background-color: transparent !important;
      }

      .custom-radio {
        font-size: 11px;
        margin-right: 1rem;
        @include media-breakpoint-up(lg) {
          font-size: 14px;
          margin-right: 2rem;
          margin-bottom: 1rem;
        }
      }

      .form-group {
        margin-bottom: 0;
      }
    }

    &--form {
      div[class|='lf-be--block'] {
        margin-bottom: $grid-gutter-width/2;
      }
    }
  }

  &--option {
    .btn {
      border: 0;
    }

    &-destination {
      .btn {
        font-weight: 600;
        background-color: #e7edfd;

        &:not(.selected) {
          color: $text;
        }

        @include media-breakpoint-down(xs) {
          padding: $grid-gutter-width/4;
        }
      }
    }

    &--wrapper {
      display: flex;
      justify-content: flex-start;
      margin-top: $grid-gutter-width/2;
      margin-right: $grid-gutter-width/4;

      @include media-breakpoint-up(md) {
        margin-top: 0;
        justify-content: flex-end;
      }
    }
  }

  &--form {
    &-item {
      &-1 {
        @include media-breakpoint-up(sm) {
          display: flex;
        }

        & > div {
          @include media-breakpoint-down(xs) {
            padding-right: $grid-gutter-width/2;
          }
        }
      }

      &-2 {
        display: flex;
      }

      & > div {
        width: 100%;
        padding: 0 8px 0 0;
      }
    }
  }

  &--datepicker {
    margin-top: 1rem;
    position: absolute;
    z-index: $zindex-fixed;
    overflow: hidden;
    width: min-content;

    &--calendar-data {
      display: flex;
      flex-direction: column;
      margin-top: -15px;
      background-color: white;
      border-radius: 8px;

      * {
        margin: 0;
      }
      &--warning {
        border-radius: 0;
      }

      .btn {
        display: block;
        width: 100%;
        position: relative;
        z-index: 1;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }

    &--departure,
    &--return {
      @extend .lf-be--datepicker;
      .btn {
        display: block;
        width: 100%;
        position: relative;
        z-index: 1;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }

    &--return {
      right: 0;
    }
  }

  &--occupancy {
    &--wrapper {
      position: relative;

      .btn {
        background: transparent;
        padding-left: 0;
        padding-right: 0;

        &:focus,
        &:hover {
          background: transparent !important;
        }
        display: inline-flex;
        align-items: center;
        svg {
          width: 8px;
          margin-left: 8px;
          path {
            stroke: $cta;
          }
        }
      }
    }

    &--content {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 9999;

      @include media-breakpoint-up(md) {
        left: auto;
        right: 0;
      }
    }
  }

  &--checkbox {
    .search-by-connections,
    .search-by-bags {
      height: 100%;
      margin-left: $grid-gutter-width/2;

      @include media-breakpoint-up(sm) {
        width: auto;
      }

      // @include media-breakpoint-down(xs) {
      //     margin-left: 0;
      //     margin-top: $grid-gutter-width/2;
      //     justify-content: center;
      // }
    }
  }

  &--select {
    .custom-select {
      padding-right: 0;
    }
  }

  &--buttons {
    .spinner-border {
      width: 1.3rem;
      height: 1.3rem;
      border-width: 2px;
      margin-left: 5px;
      opacity: 0.3;
    }
  }

  .focus-dump-button {
    opacity: 0;
    position: absolute;
    left: -999999px;
    top: -999999px;
  }

  input,
  .autocomplete-input {
    @extend .form-control !optional;
    background-color: $input-bg;
    border: 0;
    height: auto;
    padding-left: 38px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &::placeholder {
      color: $text;
    }

    &:focus {
      &::placeholder {
        color: transparent;
      }
    }
  }

  .autocomplete-input {
    background-image: url("data:image/svg+xml;utf8,<svg width='16' height='22' viewBox='0 0 16 22' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M15.2 8.39999C15.2 6.39999 14.4 4.50001 13 3.10001C11.6 1.70001 9.70001 0.899994 7.70001 0.899994C5.70001 0.899994 3.80002 1.70001 2.40002 3.10001C1.00002 4.50001 0.200012 6.39999 0.200012 8.39999C0.200012 9.69999 0.600012 11 1.20001 12.2L7 21C7.1 21.2 7.29998 21.3 7.59998 21.3C7.89998 21.3 8.10001 21.2 8.20001 21L13.6 12.9L14.1 12.1C14.8 11 15.2 9.69999 15.2 8.39999ZM10.1 10.8C9.39998 11.5 8.59998 11.8 7.59998 11.8C6.59998 11.8 5.79998 11.4 5.09998 10.8C4.39998 10.1 4.09998 9.29999 4.09998 8.29999C4.09998 7.39999 4.49998 6.49999 5.09998 5.79999C5.79998 5.09999 6.59998 4.79999 7.59998 4.79999C8.49998 4.79999 9.39998 5.19999 10.1 5.79999C10.8 6.49999 11.1 7.29999 11.1 8.29999C11.2 9.29999 10.8 10.2 10.1 10.8Z' fill='%2339414E'/></svg>");
  }

  .lf-be--block--departure_date,
  .lf-be--block--return_date {
    position: relative;
    input {
      background-repeat: no-repeat;
      background-position: 12px;
      padding-top: 18px;
      padding-bottom: 6px;
      background-image: url("data:image/svg+xml;utf8,<svg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M16.1 2H14.3V0.200012H12.5V2H5.40002V0.200012H3.59998V2H1.80005C1.30005 2 0.9 2.2 0.5 2.5C0.2 2.8 0 3.29999 0 3.79999V16.3C0 16.8 0.2 17.2 0.5 17.6C0.8 17.9 1.30005 18.1 1.80005 18.1H16C16.5 18.1 16.9 17.9 17.3 17.6C17.6 17.3 17.8 16.8 17.8 16.3V3.79999C17.8 3.29999 17.6 2.9 17.3 2.5C17 2.1 16.6 2 16.1 2ZM16.1 16.2H1.90002V6.39999H16.1V16.2Z' fill='%2339414E'/></svg>");
    }
    label {
      font-size: 11px;
      position: absolute;
      top: 6px;
      left: 40px;
    }
  }

  .vc-container {
    border-color: $light-gray;
    color: $text;
    --gray-800: #{$text};
    --text-lg: #{$font-size-base};
  }

  // gestione icone autocomplete
  .lf-be--autocomplete {
    li {
      cursor: pointer;
      transition: $transition-base;
      position: relative;
      background: none;

      &:hover {
        background: $gray-100;
      }

      &[data-type='airport'] {
        //margin-left:$grid-gutter-width;
        border-left: $grid-gutter-width solid transparent;
      }

      &:before {
        content: '';
        position: absolute;
        width: 24px;
        height: 24px;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
        background-size: contain;
        background-position: left center;
        opacity: 0.35;
      }

      &[data-type='city']:before {
        background-image: url("data:image/svg+xml;utf8,<svg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M22.7629 18.9242H21.1981V16.9682C21.785 16.7482 22.225 15.9903 22.225 15.1101C22.225 14.0342 21.6138 13.1786 20.8313 13.1786C20.0734 13.1786 19.4375 14.0344 19.4375 15.1101C19.4375 15.9903 19.8776 16.7482 20.4644 16.9682V18.9242H18.0928L18.093 0.464591C18.093 0.195634 17.8974 0 17.6284 0H11.1492C10.8802 0 10.6846 0.195621 10.6846 0.464591V4.20542L11.8827 4.0098C11.956 4.0098 12.0293 3.98541 12.1027 3.98541C12.8852 3.98541 13.5452 4.62106 13.5452 5.42791V18.9242H12.5673V5.45236C12.5673 5.15901 12.2983 4.93882 12.0294 4.98777L5.55016 6.03902C5.33015 6.08797 5.15892 6.25903 5.15892 6.50362V18.9241H2.78728V16.9681C3.37412 16.7481 3.81418 15.9902 3.81418 15.11C3.81418 14.0341 3.20293 13.1785 2.42045 13.1785C1.63797 13.1785 1.02672 14.0343 1.02672 15.11C1.02672 15.9902 1.46673 16.7481 2.05361 16.9681V18.9241H0.464591C0.195634 18.9241 0 19.1442 0 19.3887V19.5354C0 19.8044 0.220009 20 0.464591 20H22.7629C23.0318 20 23.2275 19.78 23.2275 19.5354V19.3887C23.2275 19.1443 23.0074 18.9241 22.7629 18.9241L22.7629 18.9242ZM15.1345 1.68708C15.1345 1.61375 15.2079 1.54041 15.2812 1.54041H16.406C16.4793 1.54041 16.5527 1.61375 16.5527 1.68708V2.81186C16.5527 2.8852 16.4793 2.95854 16.406 2.95854H15.2812C15.2079 2.95854 15.1345 2.8852 15.1345 2.81186V1.68708ZM15.1345 4.74332C15.1345 4.66998 15.2079 4.59664 15.2812 4.59664H16.406C16.4793 4.59664 16.5527 4.66998 16.5527 4.74332V5.84352C16.5527 5.91685 16.4793 5.99019 16.406 5.99019H15.2812C15.2079 5.99019 15.1345 5.91685 15.1345 5.84352V4.74332ZM15.1345 7.77501C15.1345 7.70168 15.2079 7.62834 15.2812 7.62834H16.406C16.4793 7.62834 16.5527 7.70168 16.5527 7.77501V8.89979C16.5527 8.97313 16.4793 9.04647 16.406 9.04647H15.2812C15.2079 9.04647 15.1345 8.97313 15.1345 8.89979V7.77501ZM15.1345 10.8312C15.1345 10.7579 15.2079 10.6846 15.2812 10.6846H16.406C16.4793 10.6846 16.5527 10.7579 16.5527 10.8312V11.956C16.5527 12.0294 16.4793 12.1027 16.406 12.1027H15.2812C15.2079 12.1027 15.1345 12.0294 15.1345 11.956V10.8312ZM15.1345 13.8875C15.1345 13.8141 15.2079 13.7408 15.2812 13.7408H16.406C16.4793 13.7408 16.5527 13.8141 16.5527 13.8875V15.0123C16.5527 15.0856 16.4793 15.1589 16.406 15.1589H15.2812C15.2079 15.1589 15.1345 15.0856 15.1345 15.0123V13.8875ZM15.1345 16.9437C15.1345 16.8704 15.2079 16.797 15.2812 16.797H16.406C16.4793 16.797 16.5527 16.8704 16.5527 16.9437V18.0685C16.5527 18.1418 16.4793 18.2152 16.406 18.2152H15.2812C15.2079 18.2152 15.1345 18.1418 15.1345 18.0685V16.9437ZM13.4719 2.95839H12.3473C12.2739 2.95839 12.2006 2.88505 12.2006 2.81172V1.68711C12.2006 1.61377 12.2739 1.54044 12.3473 1.54044H13.472C13.5454 1.54044 13.6187 1.61377 13.6187 1.68711V2.81189C13.6187 2.88506 13.5452 2.95839 13.4719 2.95839L13.4719 2.95839ZM9.60879 7.77501C9.60879 7.70168 9.68213 7.62834 9.75546 7.62834H10.8802C10.9536 7.62834 11.0269 7.70168 11.0269 7.77501V8.89979C11.0269 8.97313 10.9536 9.04647 10.8802 9.04647H9.75546C9.68213 9.04647 9.60879 8.97313 9.60879 8.89979V7.77501ZM9.60879 10.8312C9.60879 10.7579 9.68213 10.6846 9.75546 10.6846H10.8802C10.9536 10.6846 11.0269 10.7579 11.0269 10.8312V11.956C11.0269 12.0294 10.9536 12.1027 10.8802 12.1027H9.75546C9.68213 12.1027 9.60879 12.0294 9.60879 11.956V10.8312ZM9.60879 13.8875C9.60879 13.8141 9.68213 13.7408 9.75546 13.7408H10.8802C10.9536 13.7408 11.0269 13.8141 11.0269 13.8875V15.0123C11.0269 15.0856 10.9536 15.1589 10.8802 15.1589H9.75546C9.68213 15.1589 9.60879 15.0856 9.60879 15.0123V13.8875ZM9.60879 16.9437C9.60879 16.8704 9.68213 16.797 9.75546 16.797H10.8802C10.9536 16.797 11.0269 16.8704 11.0269 16.9437V18.0685C11.0269 18.1418 10.9536 18.2152 10.8802 18.2152H9.75546C9.68213 18.2152 9.60879 18.1418 9.60879 18.0685V16.9437ZM6.65045 7.77501C6.65045 7.70168 6.72378 7.62834 6.79712 7.62834H7.9219C7.99524 7.62834 8.06857 7.70168 8.06857 7.77501V8.89979C8.06857 8.97313 7.99524 9.04647 7.9219 9.04647H6.79712C6.72378 9.04647 6.65045 8.97313 6.65045 8.89979V7.77501ZM6.65045 10.8312C6.65045 10.7579 6.72378 10.6846 6.79712 10.6846H7.9219C7.99524 10.6846 8.06857 10.7579 8.06857 10.8312V11.956C8.06857 12.0294 7.99524 12.1027 7.9219 12.1027H6.79712C6.72378 12.1027 6.65045 12.0294 6.65045 11.956V10.8312ZM6.65045 13.8875C6.65045 13.8141 6.72378 13.7408 6.79712 13.7408H7.9219C7.99524 13.7408 8.06857 13.8141 8.06857 13.8875V15.0123C8.06857 15.0856 7.99524 15.1589 7.9219 15.1589H6.79712C6.72378 15.1589 6.65045 15.0856 6.65045 15.0123V13.8875ZM6.65045 16.9437C6.65045 16.8704 6.72378 16.797 6.79712 16.797H7.9219C7.99524 16.797 8.06857 16.8704 8.06857 16.9437V18.0685C8.06857 18.1418 7.99524 18.2152 7.9219 18.2152H6.79712C6.72378 18.2152 6.65045 18.1418 6.65045 18.0685V16.9437Z' fill='%2339414E'/></svg>");
      }
      &[data-type='airport']:before {
        background-image: url("data:image/svg+xml;utf8,<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M15.4865 0.00020955C15.1175 0.00625815 14.7656 0.1004 14.458 0.25038C13.8431 0.550027 13.3525 1.03161 12.9851 1.52184C12.9778 1.53316 12.9708 1.54479 12.9641 1.55658L10.5392 5.30168L1.90267 5.67003C1.67467 5.67996 1.46762 5.80574 1.35363 6.00349L0.0891186 8.17823C-0.0178973 8.36403 -0.0292213 8.59 0.0588745 8.78543C0.14697 8.98086 0.32378 9.12215 0.533781 9.16495L7.56547 10.6241L6.40502 12.8058L4.17457 13.3964C4.00536 13.4416 3.86066 13.5514 3.77165 13.7021L2.84745 15.2864C2.74741 15.4592 2.72989 15.6676 2.79983 15.8547C2.86978 16.0417 3.01992 16.1875 3.20883 16.2522L6.64824 17.4542L9.44154 19.8445C9.59307 19.9712 9.79299 20.0244 9.98748 19.9895C10.182 19.9546 10.351 19.8354 10.449 19.6638L11.3592 18.0795C11.4471 17.9283 11.4721 17.7487 11.4286 17.5793L10.8312 15.3489L12.1374 13.2504L16.9246 18.6078C17.0673 18.7681 17.2782 18.85 17.4916 18.828C17.705 18.806 17.8947 18.6827 18.0016 18.4965L19.2523 16.3218C19.3653 16.125 19.3706 15.8841 19.2662 15.6825L15.2712 8.0326L17.3069 4.06508C17.3144 4.05143 17.3214 4.03747 17.3279 4.02335C17.5695 3.4605 17.7435 2.80164 17.6961 2.11956C17.6486 1.43743 17.3094 0.697498 16.5983 0.285245V0.278266C16.2416 0.0740053 15.8554 -0.00586849 15.4866 0.000333369L15.4865 0.00020955ZM15.4933 1.3134C15.6349 1.30875 15.7743 1.34876 15.9311 1.43841C16.2436 1.61956 16.3357 1.83483 16.3618 2.20971C16.388 2.58473 16.2767 3.07888 16.0978 3.49514L13.9231 7.72646C13.8238 7.92142 13.8265 8.15238 13.9299 8.34498L17.9183 15.9742L17.3067 17.0372L12.8809 12.0761L13.3393 11.3396C13.4504 11.1905 13.4941 11.0018 13.46 10.8189C13.4259 10.6362 13.317 10.4759 13.1597 10.3767C13.0023 10.2778 12.8108 10.2488 12.6312 10.297C12.4516 10.3453 12.3004 10.4664 12.2138 10.631L9.54569 14.8901C9.4455 15.0469 9.41526 15.2383 9.46225 15.4182L10.0668 17.6556L9.69848 18.3087L7.43329 16.3702C7.37001 16.3153 7.29697 16.2728 7.21802 16.245L4.41079 15.2584L4.78612 14.6191L7.03034 14.0145C7.20839 13.9678 7.3593 13.8497 7.44724 13.688L9.80966 9.24828C9.89264 9.09163 9.91001 8.90846 9.8579 8.73895C9.80578 8.56958 9.68838 8.42783 9.53173 8.34485C9.37508 8.26187 9.19191 8.24466 9.02256 8.29677C8.8532 8.34888 8.71144 8.46613 8.62846 8.62293L8.21855 9.39408L1.70779 8.04615L2.32615 6.99008L10.9353 6.62173C11.1527 6.6132 11.3525 6.49921 11.4702 6.31604L14.0551 2.32096C14.0608 2.31321 14.07 2.30778 14.0759 2.30018L14.0828 2.28622C14.3521 1.93648 14.7136 1.61231 15.0416 1.45242C15.2112 1.36976 15.3518 1.31811 15.4933 1.31346L15.4933 1.3134Z' fill='%2339414E'/></svg>");
      }
    }
  }
}
</style>
